/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @version 1.1.0
 * @since 1.1.0
 */

export const defaultRowHeight = 25;
export const doubleRowHeight = 45;
export const nextRowHeight = 24;
export const defaultRowPadding = 10;
export const densityRowPadding = 4;
